import React, { useState, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { useNavigate, useParams } from "react-router-dom";
import url from "../../config.js";
import intelogicon from "../../assets/icons/intelog_new_png.png";
import "../login/login.scss";

const domain = url.domain;

// Auto-verifies the token on mount by POSTing to /api/auth/verify-email.
function VerifyEmail() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [status, setStatus] = useState("verifying"); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;
    const verify = async () => {
      try {
        const res = await fetch(`${domain}/api/auth/verify-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        const data = await res.json();
        if (cancelled) return;
        if (data.success) {
          setStatus("success");
          setMessage(data.message || "Your email has been verified. You can now sign in.");
        } else {
          setStatus("error");
          setMessage(data.message || "Verification link is invalid or has expired.");
        }
      } catch {
        if (cancelled) return;
        setStatus("error");
        setMessage("Something went wrong. Please try again.");
      }
    };
    verify();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="login-root">
      <CssBaseline />
      <div className="login-split-container">

        {/* Left — branding */}
        <div className="login-left-side">
          <div className="branding-content">
            <div className="logo-wrapper">
              <img src={intelogicon} alt="INTELOG" className="brand-logo" />
            </div>
            <div className="quote-section">
              <h1 className="brand-headline">Verify your email</h1>
              <p className="brand-description">
                Confirming your email address activates your Intelog account.
              </p>
            </div>
          </div>
        </div>

        {/* Right — status */}
        <div className="login-right-side">
          <div className="form-wrapper">
            {status === "verifying" && (
              <div className="form-container">
                <div className="form-header">
                  <h2 className="form-title">Verifying…</h2>
                  <p className="form-subtitle">Please wait while we confirm your email address.</p>
                </div>
              </div>
            )}

            {status === "success" && (
              <div className="success-container">
                <div className="success-icon-container">
                  <div className="success-icon-circle">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </div>
                </div>
                <div className="success-message-box">
                  <h2 className="success-message-title">Email verified</h2>
                  <p className="success-message-text">{message}</p>
                </div>
                <button type="button" className="form-button" onClick={() => navigate("/")}>
                  Go to Login
                </button>
              </div>
            )}

            {status === "error" && (
              <div className="form-container">
                <div className="form-header">
                  <h2 className="form-title">Verification failed</h2>
                  <p className="form-subtitle">{message}</p>
                </div>
                <button type="button" className="form-button" onClick={() => navigate("/")}>
                  Go to Login
                </button>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default VerifyEmail;
